export enum TransactionsEnum {
  'TED' = 1,
  'Depósito' = 2,
  'TEF' = 3,
  'CNAB' = 4,
  'PIX' = 5,
  'DDA' = 7,
  'C/C Cliente' = 8,
}
